<template>
<div class="np-alert np-alert-ani np-alert-msg" v-if="showAlert" 
	:style="opts.style"
	:class="setAlertClass">
	<div :style="opts.contentStyle" 
		v-html = "msg"
	></div>
</div>
</template>

<script>
export default {
	props:[
		"msg",
		"show",
		"duration",
		"onClose",
		"options"
	],
	data: function(){
		return {
			showClass:false,
			showAlert: false,
			opts:null
		}
	},
	computed: {
		setAlertClass: function(){
			var tmp = {'np-alert_show':this.showClass};
			if(this.opts && this.opts["skin"]){
				tmp[this.opts["skin"]] = true;
			}
			return tmp;
		}
	},
	created: function(){
		this.opts = this.options || {};
	},
	mounted: function(){
		var _this = this;
			_this.showAlert = _this.show;
			_this.autoClose();
		setTimeout(function(){
			_this.showClass = _this.show;
		});
	},
	methods:{
		autoClose: function(){
			var _this = this, duration = _this.duration || 2500;				
			//自动关闭
			if(duration){
				setTimeout(function(){
					_this.close();
				},duration);
			}			
		},
		close:function(){
			var _this = this;
				_this.showClass = false;
			if(typeof _this.opts.onClose === "function"){
				_this.opts.onClose();
			}
			setTimeout(function(){
				_this.showAlert = false;
			},150);
		}
	}
}
</script>
<style lang="scss">
$alert-rs: $border-radius-xs;
$alert-padding: $space-padding-md;
$alert-color:$color-white;
.np-alert-ani {
	@include  trans-animate-easeout();
}
.np-alert {
	z-index: 3988;
	&-msg {
		position: fixed;
		left: 50%;
		border-radius: $alert-rs;
		top: 110%;
		background-color: rgba(0,0,0,0.6);
		padding: calc($alert-padding / 2);
		color: $alert-color;
		-webkit-transform: translate(-50%,-50%);
		-ms-transform: translate(-50%,-50%);
		-moz-transform: translate(-50%,-50%);
		transform: translate(-50%,-50%);
	}
	&_show {
		left: 50%;
		top: 50%;
	}
}
</style>
